import React, { useEffect, useState } from "react";
import BackBtn from "../../common/backBTN";

function ChangePassword({ showAlert }) {
  const [data, setData] = useState({
    old_password: "",
    new_password: "",
    new_password_confirmation: "",
  });

  const [passwordShown, setPasswordShown] = useState({
    old_password: false,
    new_password: false,
    new_password_confirmation: false,
  });

  const [error, setError] = useState("");
  const [token, setToken] = useState(localStorage.getItem("token"));

  useEffect(() => {
    setToken(localStorage.getItem("token"));
  }, []);

  const handleChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  const togglePasswordVisibility = (name) => {
    setPasswordShown((prev) => ({
      ...prev,
      [name]: !prev[name],
    }));
  };

  const updatePassword = () => {
    if (!data.old_password) return setError("Please enter your current password.");
    if (!data.new_password)
      return setError("Please enter your new password.");
    if (!data.new_password_confirmation)
      return setError("Please confirm your new password.");
    if (data.new_password !== data.new_password_confirmation)
      return setError("Passwords do not match.");
    if (!/^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/.test(data.new_password))
      return setError(
        "New Password must contain at least one number, one letter, and be 8 characters long."
      );

    setError("");
    fetch(`${process.env.REACT_APP_API_URL}/api/user-pwd`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((res) => {
        if (!res.ok) return res.json().then((err) => Promise.reject(err));
        return res.json();
      })
      .then(() => {
        showAlert("Password changed successfully. Please login again.");
        setTimeout(() => (window.location.href = "/login"), 1500);
      })
      .catch((err) => {
        console.error("Error:", err);
        setError(err?.message || "Failed to change password. Please try again.");
      });
  };

  return (
    <div id="mc-animate-container" className="v-base v-detail-base fade-enter-done">
      <div>
        {/* === Header === */}
        <div className="mc-header-wrap">
          <div
            id="mc-header"
            className="mc-navbar-blue mc-loginChange mc-default-header am-navbar am-navbar-light"
          >
            <BackBtn />
            <div className="am-navbar-title">Change login password</div>
            <div className="am-navbar-right" />
          </div>
          <div className="am-whitespace am-whitespace-sm mc-whitespace" />
        </div>

        {/* === Form === */}
        <form className="flex-container security-center-container" onSubmit={(e) => e.preventDefault()}>
          <div className="am-whitespace am-whitespace-lg white-space" />

          {/* Old Password */}
          <div className="account-form no-mgbtm">
            <div className="account-form-group">
              <div className="mc-account-list">
                <svg className="am-icon am-icon-lock_b49219f4 am-icon-md txt-svg">
                  <use xlinkHref="#lock_b49219f4" />
                </svg>
                <input
                  type={passwordShown.old_password ? "text" : "password"}
                  className="input-base"
                  placeholder="Enter your current password."
                  name="old_password"
                  value={data.old_password}
                  onChange={handleChange}
                />
              </div>
              <div className="eye-group" onClick={() => togglePasswordVisibility("old_password")}>
                <svg
                  className="am-icon am-icon-eyes-hide_2e21a0e3 am-icon-md am-icon-eyes"
                  style={{ color: "rgb(165,165,165)" }}
                >
                  <use
                    xlinkHref={
                      passwordShown.old_password
                        ? "#eyes-open_2e21a0e3"
                        : "#eyes-hide_2e21a0e3"
                    }
                  />
                </svg>
              </div>
            </div>
          </div>

          {/* New Password */}
          <div className="account-form no-mgbtm">
            <div className="account-form-group">
              <div className="mc-account-list">
                <svg className="am-icon am-icon-passwordBetter_0bd7a252 am-icon-md txt-svg">
                  <use xlinkHref="#passwordBetter_0bd7a252" />
                </svg>
                <input
                  type={passwordShown.new_password ? "text" : "password"}
                  className="input-base"
                  placeholder="Please enter a new password"
                  name="new_password"
                  value={data.new_password}
                  onChange={handleChange}
                />
              </div>
              <div className="eye-group" onClick={() => togglePasswordVisibility("new_password")}>
                <svg
                  className="am-icon am-icon-eyes-hide_2e21a0e3 am-icon-md am-icon-eyes"
                  style={{ color: "rgb(165,165,165)" }}
                >
                  <use
                    xlinkHref={
                      passwordShown.new_password
                        ? "#eyes-open_2e21a0e3"
                        : "#eyes-hide_2e21a0e3"
                    }
                  />
                </svg>
              </div>
            </div>
          </div>

          {/* Confirm Password */}
          <div className="account-form no-mgbtm">
            <div className="account-form-group">
              <div className="mc-account-list">
                <svg className="am-icon am-icon-passwordAgain_4b9460bf am-icon-md txt-svg">
                  <use xlinkHref="#passwordAgain_4b9460bf" />
                </svg>
                <input
                  type={passwordShown.new_password_confirmation ? "text" : "password"}
                  className="input-base"
                  placeholder="Confirm new password"
                  name="new_password_confirmation"
                  value={data.new_password_confirmation}
                  onChange={handleChange}
                />
              </div>
              <div className="eye-group" onClick={() => togglePasswordVisibility("new_password_confirmation")}>
                <svg
                  className="am-icon am-icon-eyes-hide_2e21a0e3 am-icon-md am-icon-eyes"
                  style={{ color: "rgb(165,165,165)" }}
                >
                  <use
                    xlinkHref={
                      passwordShown.new_password_confirmation
                        ? "#eyes-open_2e21a0e3"
                        : "#eyes-hide_2e21a0e3"
                    }
                  />
                </svg>
              </div>
            </div>
          </div>

          {/* Info & Error */}
          <p className="txt-gray" style={{ marginTop: "10px" }}>
            * Please enter 8+ characters using letters and numbers only.
          </p>
          {error && (
            <p style={{ color: "red", marginTop: "5px", textAlign: "center" }}>
              {error}
            </p>
          )}

          {/* Submit */}
          <div className="am-whitespace am-whitespace-lg new-space-bet" />
          <a
            role="button"
            className="btn-gray enterButton am-button"
            onClick={updatePassword}
          >
            <span>Submit</span>
          </a>
        </form>
      </div>
    </div>
  );
}

export default ChangePassword;
